import {
    Button,
    Box,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    IconButton
} from "@mui/material";
import "../styles/bidding-card.scss";
import React from "react";
import { useEffect, useState } from "react";
import { betBidding, tryBet, getBiddingById, setFavoriteBidding } from "../components/api";
import { $isAuth, $userData, setNotificationMessage, setShowNotification } from "../store";
import * as signalR from '@microsoft/signalr';
import { CarCard, CountdownTimer, ImageWithDefault, Popup } from "../components";
import { useParams, useSearchParams } from "react-router-dom";
import { ArrowBack, Star, StarBorderOutlined } from "@mui/icons-material";
import { useUnit } from "effector-react";

const userBetEmodji = ["🥇", "🥈", "🥉"];
const webSocketUrl = process.env.REACT_APP_SOCKET_URL;

export const BiddingCard = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const [connection, setConnection] = useState(null);
    const [popupItems, setPopupItems] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [isFavorite, setIsFavorite] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    const [openDialog, setOpenDialog] = useState(false);
    const [bidding, setBidding] = useState({
        id: 0,
        cars: [],
        city: {
            id: 0,
            name: ""
        },
        duration: 0,
        startPrice: 0,
        dateEndBidding: null,
        currentPrice: 0,
        betStep: 0,
        isFavorite: false,
        userBets: []
    });
    const [biddingChanged, setBiddingChanged] = useState(false);
    const [betPrice, setBetPrice] = useState(0);

    const userData = useUnit($userData);
    const isAuth = useUnit($isAuth);

    useEffect(() => {
        if (!connection) {
            const newConnection = new signalR.HubConnectionBuilder()
                .withUrl(`${webSocketUrl}/sockets/biddings`, {
                    skipNegotiation: true,
                    transport: signalR.HttpTransportType.WebSockets
                })
                .withAutomaticReconnect()
                .build();

            setConnection(newConnection);
        }
    }, []);

    useEffect(() => {
        if (id) {
            getBiddingById(id)
                .then(data => {
                    setBidding(data);
                    setIsFavorite(data.isFavorite);
                    setIsLoaded(true);
                })
                .catch(error => {
                    console.error("Ошибка при загрузке данных торга:", error);
                    setNotificationMessage("Не удалось загрузить данные торга");
                    setShowNotification(true);
                    setIsLoaded(true);
                });
        }
    }, [id]);

    useEffect(() => {
        if (connection && bidding.id) {
            connection.start().then(() => {
                connection.invoke("SendBidding", bidding.id);
                connection.on("BiddingUpdate", (data) => {
                    if (data)
                        setBidding(JSON.parse(data));
                });
            }).catch((exception) => {
                console.error("Ошибка подключения WebSocket:", exception);
            });
        }
    }, [connection, bidding.id]);

    useEffect(() => {
        const originalStyle = window.getComputedStyle(document.body).overflow;

        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = originalStyle;
        };
    }, []);

    const handleClickOpen = () => {
        const currentBetPrice = bidding.currentPrice + bidding.betStep;
        setBetPrice(currentBetPrice);
        tryBet({ biddingId: bidding.id, betPrice: currentBetPrice })
            .then(data => {
                setBiddingChanged(false);
                if (data?.hasActiveSubscription && data?.currentUserNotHasTopBet) {
                    if (data?.currentBetIsMax) {
                        setOpenDialog(true);
                    }
                    else {
                        getBiddingById(bidding.id)
                            .then(data => {
                                setBidding(data);
                                setBetPrice(data.currentPrice + data.betStep);
                                setBiddingChanged(true);
                                setOpenDialog(true);
                            })
                            .catch(error => {
                                setNotificationMessage("Произошла непредвиденная ошибка");
                                setShowNotification(true);
                            })
                    }
                }
                else if (!data?.hasActiveSubscription) {
                    setPopupItems(<div style={{ padding: "10px", display: "flex", flexDirection: "column" }}>
                        <Typography variant="h6">
                            Для участия в аукционе необходимо оплатить подписку!
                        </Typography>
                        <a href="/payment">
                            <Button variant="contained" style={{ margin: 3 }}>
                                Оформить подписку
                            </Button>
                        </a>
                    </div>)
                    setShowPopup(true);
                }
                else if (!data?.currentUserNotHasTopBet) {
                    setNotificationMessage("Ваша ставка уже лидирует");
                    setShowNotification(true);
                }
                else {
                    setNotificationMessage("Произошла непредвиденная ошибка");
                    setShowNotification(true);
                }
            })
            .catch(error => {
                let errorMessageData = error?.response?.data?.errors;
                if (error?.response?.status === 401) {
                    errorMessageData = ["Для возможности делать ставки необходимо авторизоваться"];
                    window.location.href = `/authorization?returnUrl=${window.location.pathname}`;
                }
                setNotificationMessage(errorMessageData
                    ? Array.from(errorMessageData).join(", ")
                    : "Произошла непредвиденная ошибка");
                setShowNotification(true);
            });
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const betBiddingClick = () => {
        betBidding({
            biddingId: id,
            betPrice: betPrice
        })
            .then(data => {
                setBidding(data);
                setBiddingChanged(false);
                setOpenDialog(false);
            })
            .catch(error => {
                const errorMessageData = error?.response?.data?.errors;
                setNotificationMessage(errorMessageData
                    ? Array.from(errorMessageData).join(", ")
                    : "Произошла непредвиденная ошибка");
                setShowNotification(true);
                setOpenDialog(false);
                getBiddingById(bidding.id)
                    .then(data => {
                        setBidding(data);
                        setBiddingChanged(false);
                    })
            });

    };

    const timeUp = (dateEnd) => {
        const now = new Date();
        const end = new Date(dateEnd);

        return now > end;
    }

    const getHidenNameAndPrice = (name, price) => {
        return `${name.slice(0, 2)}*** - ${price.toLocaleString()} ₽`
    }

    const backToBiddings = () => {
        window.location.href = searchParams.get("returnUrl") ?? "/currentBiddings";
    }

    const showPhoto = () => {
        if (userData.status !== 4) {
            setPopupItems(<div style={{ padding: "10px", display: "flex", flexDirection: "column" }}>
                <Typography variant="h6">
                    Для просмотра фотографий автомобиля необходимо оплатить подписку!
                </Typography>
                <a href="/payment">
                    <Button variant="contained" style={{ margin: 3 }}>
                        Оформить подписку
                    </Button>
                </a>
            </div>)
            setShowPopup(true);
            return;
        }
        const carsMedia = bidding.cars?.filter(car => car.media)?.map(car => {
            return {
                name: car.model.name,
                url: car.media
            }
        })
        if (carsMedia?.length > 1) {
            setPopupItems(<div style={{ padding: "10px", display: "flex", flexDirection: "column" }}>
                <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                    Выберите автомобиль
                </Typography>

                {carsMedia.map(item =>
                    <a href={item.url} target="_blanc">
                        <Button variant="contained" style={{ margin: 3 }}>
                            {item.name}
                        </Button>
                    </a>)}
            </div>)
            setShowPopup(true);
        }
        else if (carsMedia?.length === 1) {
            window.open(carsMedia[0].url, '_blank');
        }
        else {
            setNotificationMessage("Ссылка на фото на найдена");
            setShowNotification(true);
        }
    }

    const showAutoteka = () => {
        if (userData.status !== 4) {
            setPopupItems(<div style={{ padding: "10px", display: "flex", flexDirection: "column" }}>
                <Typography variant="h6">
                    Для получения отчета по автомобилю необходимо оплатить подписку!
                </Typography>
                <a href="/payment">
                    <Button variant="contained" style={{ margin: 3 }}>
                        Оформить подписку
                    </Button>
                </a>
            </div>)
            setShowPopup(true);
            return;
        }
        const carsReports = bidding.cars?.filter(car => car.report)?.map(car => {
            return {
                name: car.model.name,
                url: car.report
            }
        })
        if (carsReports?.length > 1) {
            setPopupItems(<div style={{ padding: "10px", display: "flex", flexDirection: "column" }}>
                <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                    Выберите автомобиль
                </Typography>

                {carsReports.map(item =>
                    <a href={item.url} target="_blanc">
                        <Button variant="contained" style={{ margin: 3 }}>
                            {item.name}
                        </Button>
                    </a>)}
            </div>)
            setShowPopup(true);
        }
        else if (carsReports?.length === 1) {
            window.open(carsReports[0].url, '_blank');
        }
        else {
            setNotificationMessage("Ссылка на автотеку на найдена");
            setShowNotification(true);
        }
    }

    const handleFavoriteClick = (e) => {
        e.stopPropagation();
        setFavoriteBidding(bidding.id, !isFavorite)
            .then(_ => {
                setIsFavorite(!isFavorite);
            })
            .catch(err => {
                if (err?.status === 401) {
                    setNotificationMessage("Для добавления лота в избранное необходимо авторизоваться");
                    setShowNotification(true);
                }
                else {
                    console.log(err);
                    setNotificationMessage("Произошла непредвиденная ошибка");
                    setShowNotification(true);
                }
            })
    };

    if (!isAuth) {
        return (
            <Popup show={true} onClose={() => window.location.href = "/"}>
                <Typography variant="h6">Для перехода к лоту необходимо авторизоваться</Typography>
                <a href={`/authorization?returnUrl=/bidding/${id}?returnUrl=/currentBiddings`}>
                    <Button variant="contained">Войти</Button>
                </a>
            </Popup>
        )
    }

    if (!bidding?.id && isLoaded)
        return (
            <Popup show={true} onClose={() => window.location.href = searchParams.get("returnUrl") ?? "/currentBiddings"}>
                <Typography variant="h6">Торг не найден</Typography>
                <a href={searchParams.get("returnUrl") ?? "/currentBiddings"}>
                    <Button variant="contained">Перейти к торгам</Button>
                </a>
            </Popup>
        )

    return (
        <div className="bidding-card__layout">
            <div className="bidding-card">
                {(bidding.id !== 0 && isLoaded) &&
                    <React.Fragment>
                        <h3 className="bidding-card__title">
                            <ArrowBack onClick={backToBiddings} />
                            {`Лот № ${bidding.id} `}
                            {`${new Date(bidding.dateStartBidding).toLocaleDateString('ru-RU')} `}
                            {bidding.cars?.length > 1 && (`Автомобильное комбо! ${bidding.cars.length} АВТО ПО ЦЕНЕ 1`)}

                        </h3>

                        <div className="bidding-card__main-information">

                            <ImageWithDefault src={bidding?.fileName} className="bidding-card__main-image" />
                            <h4>🌍 {bidding.city?.name}</h4>
                            {bidding.cars.map(item =>
                                <CarCard car={item} key={item.id} />
                            )}
                        </div>

                        <div className="bidding-card__functional_info">
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around", width: "100%", textAlign: "center" }}>
                                <div>
                                    <Box>
                                        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                            Длительность:
                                        </Typography>
                                        <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                                            {bidding.duration}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                            Начальная цена:
                                        </Typography>
                                        <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                                            {bidding.startPrice.toLocaleString()} ₽
                                        </Typography>
                                    </Box>
                                </div>
                                <div>
                                    <Box>
                                        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                            Оставшееся время:
                                        </Typography>
                                        <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                                            {bidding?.dateEndBidding ? <CountdownTimer endTime={bidding.dateEndBidding} /> : "Время вышло!"}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                                            Текущая цена:
                                        </Typography>
                                        <Typography variant="h6" sx={{ whiteSpace: "nowrap" }}>
                                            {bidding.currentPrice.toLocaleString()} ₽
                                        </Typography>
                                    </Box>
                                </div>

                            </div>
                            <div className="bidding-card__user-bets">
                                {bidding.userBets.map((userBet, index) => (
                                    <p key={index}>{index < 3 && `${userBetEmodji[index]} `}{getHidenNameAndPrice(userBet.user.fullName, userBet.betPrice.toLocaleString())}</p>
                                ))}
                                <div className="bidding-card__photo-autoteka" style={{ width: "95%" }}>
                                    <Button
                                        variant="contained"
                                        onClick={showPhoto}>
                                        Фото
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={showAutoteka}>
                                        Автотека
                                    </Button>
                                </div>
                                {!timeUp(bidding.dateEndBidding) && <Button
                                    variant="contained"
                                    color="primary"
                                    className="bidding-card__bet-button"
                                    onClick={() => handleClickOpen()}
                                >
                                    {(bidding.currentPrice + bidding.betStep).toLocaleString()} ₽
                                </Button>}
                            </div>
                            <IconButton
                                className="bidding-card__favorite-button"
                                onClick={handleFavoriteClick}
                            >
                                {isFavorite
                                    ? <Star />
                                    : <StarBorderOutlined />}
                            </IconButton>
                        </div>
                    </React.Fragment>
                }
            </div>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Подтвердите ставку"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {biddingChanged && (`Стоимость торга увлечилась, текущая стоимость: ${bidding.currentPrice}. `)}
                        Вы подтверждаете ставку {(bidding.currentPrice + bidding.betStep).toLocaleString()}&nbsp;₽?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => betBiddingClick()} autoFocus>
                        Да
                    </Button>
                    <Button onClick={handleClose}>Нет</Button>
                </DialogActions>
            </Dialog>
            <Popup show={showPopup} onClose={() => setShowPopup(false)}>
                {popupItems}
            </Popup>
        </div>
    )
}